export const getDefaultQuantity = headCount => (headCount >= 40 ? 2 : 1);

export const templateOptions = {
	AVERY_25395: 'avery25395',
	STANDARD: 'standard',
	TWO_PER_PAGE: 'twoPerPage',
};
